@if (isLoading$ | async) {
  <div class="loader-component position-fixed top-0 end-0 bottom-0 start-0 fade show" tabindex="-1" role="dialog">
    <div class="position-absolute top-50 start-50 translate-middle">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
}
@if (isLoading$ | async) {
  <div class="modal-backdrop fade show"></div>
}
